import {Observable, Subscription} from 'rxjs';

import Media          from '../../Media/Media';
import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToMediaStoreUpdate = (
    mediaUpdate$: Observable<Media>,
    playbackStore: IPlaybackStore
): Subscription =>
    mediaUpdate$
        .subscribe(nextMedia => {
            const currentMedia = playbackStore.value.media;

            if (currentMedia && currentMedia.src === nextMedia.src) return;

            playbackStore.actions.deriveMedia(nextMedia);

            if (nextMedia.isLoaded) {
                playbackStore.actions.load();
            } else {
                playbackStore.actions.unload();
            }
        });

export default subscribeToMediaStoreUpdate;